import React, { useEffect, useCallback, useState} from 'react';
import Forces from './Forces.js';
import EffectParameterSlider from '../EffectParameterSlider.js';
import {connect} from 'react-redux';

const ScriptVariables = ({effect, variables, sequencerEngine}) => { 
    if (!variables) {
        return [];
    }
    return (
          <div className="script-variables">
            {variables 
             .filter(x => x &&  x.name)
             .filter(x => !x.hide)
             .sort(
                 (x,y) => x.name.localeCompare(y.name))
             .map(
                 variable =>
                     <EffectParameterSlider
                       name={variable.name}
                       key={variable.id}
                       min={variable.min}
                       max={variable.max}
                       step={variable.max - Math.floor(variable.max) !== 0 ||
                             variable.min - Math.floor(variable.min) !== 0 ||
                             Math.abs(variable.max - variable.min) < 2 ? 0.01 : 1}
                       parameter={variable}
                       lfoEnabled={true}
                       sequencerEngine={sequencerEngine}
                       isParameter={true}
                       effectNumber={0}
                     />)}
            {effect.forces && <Forces effect={effect}/>}
          </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
        variables: state.effects.scriptVariables[props.effect.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScriptVariables);
